<template>
  <div class="q-mt-lg">
    <div
      class="row col-12 q-ml-md justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
      style="font-size: 16px"
    >
      <span> Produtos desta Necessidade</span>

      <q-btn
        label="Imprimir"
        icon="sym_o_print"
        no-caps
        class="q-ml-auto"
        style="border-radius: 8px; background-color: #304f78; color: white"
        @click="abrirImpressaoEmNovaAba"
      />
    </div>
    <q-table
      flat
      table-header-style="background-color: #d9effc"
      color="primary"
      :rows="rows"
      dense
      class="tabela-tamanho-fixo"
      :columns="columns"
      :loading="disable"
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      row-key="product_id"
      @request="handleRequest"
    >
      <template v-slot:body-cell-historico="props">
        <q-td :props="props">
          <q-btn
            v-if="!props.row.purchase_order_id"
            dense
            flat
            round
            icon="history"
            color="secundary"
            size="md"
            @click="abrirHistoricoItem(props.row)"
          />
        </q-td>
      </template>
      <template #body-cell-responsavel="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row items-center">
            <span>{{ props.row.responsavel_nome }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-product_codigo="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              v-if="props.row.editar == true"
              dense
              v-model="props.row.product_codigo"
              outlined
              label="Codigo"
            >
            </q-input>
            <span v-else>{{ props.row.product_codigo }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-cost_center_code="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row text-brand-5 text-weight-bold">
            <SelectCentroCustosVersao2
              label="Unid. Controle"
              v-if="props.row.editar == true"
              v-model="props.row.item_cost_center_code_new"
              style="max-width: 160px; width: 160px"
            />

            <span v-else>
              <div
                v-if="
                  props.row.item_cost_center_code &&
                  props.row.item_cost_center_code.code
                "
              >
                {{ props.row.item_cost_center_code.code }}
              </div>
              <div v-else>{{ props.row.item_cost_center_code }}</div>
            </span>
          </div>
        </q-td>
      </template>

      <template #body-cell-editar="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-btn
              v-if="props.row.editar == undefined || props.row.editar == false"
              @click="iniciarEdicao(props.row)"
              class="q-ml-md"
              icon="sym_o_edit"
              round
              flat
              color="primary"
              :disable="props.row.purchase_order_id != null"
            />

            <q-btn
              v-if="props.row.editar == true"
              @click="editar(props.row), (props.row.editar = !props.row.editar)"
              icon="sym_o_check"
              flat
              round
              color="positive"
            />
          </div>
        </q-td>
      </template>

      <template #body-cell-quantidade_necessaria="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              v-if="props.row.editar == true"
              style="margin-top: 20px"
              dense
              v-model="props.row.quantidadeNecessaria"
              outlined
              type="number"
              min="0"
              :rules="[(val) => val >= 0 || 'Quantidade deve ser positiva']"
            />
            <span v-else>{{
              Number(props.row.quantidade_necessaria).toFixed(2)
            }}</span>
          </div>
        </q-td>
      </template>
      <template #body-cell-pedidoCompra="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div style="font-size: 15px; font-weight: bolder" class="row">
            <a v-if="props.row.purchase_order_id != null">{{
              props.row.purchase_order_id
            }}</a>
            <span v-else>NÃO</span>
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <q-dialog v-model="historicoItemDialog">
      <q-card style="min-width: 70vw; max-width: 90vw">
        <q-bar class="bg-primary text-white">
          <q-space />
          <div class="text-h6">
            Histórico de Edições - {{ itemSelecionado?.produto_nome }}
          </div>
          <q-space />
          <q-btn dense flat icon="close" v-close-popup />
        </q-bar>

        <q-card-section style="height: 400px" class="scroll">
          <q-linear-progress
            v-if="historicoItemCarregando"
            indeterminate
            size="3px"
          />

          <div v-if="historicoItemErro" class="text-negative q-pa-md">
            {{ historicoItemErro }}
          </div>

          <q-table
            v-else
            flat
            :columns="columnsHistoricoItem"
            :rows="historicoItemItens"
            row-key="editado_em"
            dense
            :rows-per-page-options="[0]"
            no-data-label="Nenhum histórico encontrado."
            class="my-sticky-dynamic"
            hide-bottom
          >
            <template v-slot:body-cell-data_edicao="props">
              <q-td :props="props">
                {{ formatarData(props.row.editado_em) }}
              </q-td>
            </template>
          </q-table>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Fechar" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
const columns = [
  {
    name: "historico",
    label: "Ver Histórico",
    align: "center",
    field: "historico",
    sortable: false,
    style: "width: 50px",
  },
  {
    name: "tempo",
    label: "Inserido em:",
    field: (row) =>
      row.created_at
        ? row.created_at.split(" ")[0].split("-").reverse().join("/") +
          " " +
          row.created_at.split(" ")[1]
        : "Sem data",
    align: "left",

    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "cost_center_code",
    label: "Unid. Controle",
    field: " cost_center_code",
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "responsavel",
    label: "Responsável",
    field: "responsavel",
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "product_codigo",
    label: "Código",
    field: (row) => row.product_codigo,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "produto",
    label: "Descrição",
    field: (row) => row.produto_nome,
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "medida",
    label: "Unid. Medida SC",
    field: (row) => row.unidade_medida_necessidade,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "medida",
    label: "Unid. Medida Catálogo",
    field: (row) => row.unidade_medida,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "quantidade_necessaria",
    label: "Qtd. de Compra",
    field: (row) => row.quantidade_necessaria,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "pedidoCompra",
    label: "Ped. Compra",
    field: "pedidoCompra",
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },

  {
    name: "editar",
    label: "Editar",
    field: "editar",
    align: "right",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute, useRouter } from "vue-router";
import SelectCentroCustosVersao2 from "../components/SelectCentroCustosVersao2.vue";
//import { get } from "core-js/core/dict";

export default {
  components: { SelectCentroCustosVersao2 },
  props: ["info", "get"],
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const selecionados = ref([]);
    const id = route.params.id;
    const historicoItemDialog = ref(false);
    const historicoItemCarregando = ref(false);
    const historicoItemItens = ref([]);
    const historicoItemErro = ref(null);
    const itemSelecionado = ref(null);
    //const tableKey = ref(0);

    const columnsHistoricoItem = [
      {
        name: "nome",
        label: "Descrição Item",
        align: "left",
        field: (row) => row.nome || itemSelecionado.value?.produto_nome || "-",
      },
      {
        name: "editado_em",
        label: "Data Edição",
        align: "left",
        field: (row) => row.editado_em,
        sortable: true,
      },
      {
        name: "editado_por",
        label: "Usuário Editor",
        align: "left",
        field: (row) =>
          row.editado_por
            ? `${row.editado_por.nome} (${row.editado_por.matricula})`
            : "-",
      },
      {
        name: "quantidade_necessaria",
        label: "Quantidade",
        align: "left",
        field: (row) => row.quantidade_necessaria || "-",
        sortable: true,
      },
    ];

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 25) => {
      try {
        const response = await store.dispatch(
          "compras/getProdutosNecessidade",
          {
            vendor_id: store.state.org.unidadeData.id,
            page,
            per_page: rowsPerPage,
            uuid: id,
          }
        );

        rows.value = response.data.data;

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;
        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro ao encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const rota = async (rota, param = "") => {
      if (param != "") {
        router.push({
          name: rota,
          params: { id: param },
        });
      } else {
        router.push({
          name: rota,
        });
      }
    };

    const deletar = async (uuid) => {
      try {
        await store.dispatch("compras/deletarProdutosNecessidade", {
          uuid: id,
          produtos: [{ produto_fora_catalogo_uuid: uuid }],
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
        emit("atualizar");
      } catch (error) {
        $q.notify({
          message: "Erro ao deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarRequisicao = async () => {
      let produtos = [];
      props.info.itens.products.forEach((e) => {
        produtos.push({
          amount: e.produto.amount,
          id: e.produto.id,
          product_id: e.produto.id,
          quantidade_necessaria: e.produto.quantidadeNecessaria,
        });
      });

      try {
        await store.dispatch("compras/criarRequisicao", {
          cost_center_id: props.info.costCenter.id,
          numero: props.info.numero,
          plantiff_id: props.info.solicitante.usuario.id,
          vendor_id: store.state.org.unidadeData.id,
          products: produtos,
        });

        $q.notify({
          message: "Requisição criada com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editar = async (dados) => {
      try {
        if (
          dados.matricula_responsavel &&
          dados.matricula_responsavel !== dados.responsavel_nome
        ) {
          await store.dispatch(
            "comprasSolicitante/editarProdutosNecessidadeNome",
            {
              uuid: id,
              uuidItem: dados.uuid_item,
              matricula_responsavel: dados.matricula_responsavel,
            }
          );
        }

        if (dados.item_cost_center_code_new) {
          await store.dispatch(
            "comprasSolicitante/editarProdutosNecessidadeCost",
            {
              uuid: id,
              uuidItem: dados.uuid_item,
              cost_center_code: dados.item_cost_center_code_new.code,
            }
          );
        }

        if (
          dados.product_codigo &&
          dados.product_codigo !== dados.codigoOriginal
        ) {
          await store.dispatch(
            "comprasSolicitante/editarProdutosNecessidadeCode",
            {
              uuid: id,
              uuidItem: dados.uuid_item,
              code: dados.product_codigo,
            }
          );
        }

        if (dados.quantidadeNecessaria !== dados.quantidadeOriginal) {
          await store.dispatch(
            "comprasSolicitante/editarQuantidadeItemNecessidade",
            {
              uuid: id,
              uuidItem: dados.uuid_item,
              quantidade: dados.quantidadeNecessaria,
            }
          );
          const index = rows.value.findIndex(
            (p) => p.uuid_item === dados.uuid_item
          );
          if (index !== -1) {
            rows.value[index].quantidade_necessaria =
              dados.quantidadeNecessaria;
          }
        }

        $q.notify({
          message: "Editado com sucesso!",
          color: "positive",
        });

        await getDados();
      } catch (error) {
        dados.quantidadeNecessaria = dados.quantidadeOriginal;

        const errorMessage =
          error.response?.data?.message ||
          "Você não tem permissão para editar a quantidade";

        $q.notify({
          message: errorMessage,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
    };

    const iniciarEdicao = (row) => {
      row.editar = true;
      row.quantidadeOriginal = row.quantidade_necessaria;
      row.quantidadeNecessaria = row.quantidade_necessaria;
      row.responsavelOriginal = row.responsavel_id;
      row.centroCustoOriginal = row.item_cost_center_code?.code;
      row.codigoOriginal = row.product_codigo;
      row.item_cost_center_code_new = null;
    };

    const removerResponsavel = async (row) => {
      try {
        await store.dispatch("comprasSolicitante/removerResponsavelProduto", {
          uuid: id,
          uuidItem: row.uuid_item,
        });

        row.matricula_responsavel = "";
        row.responsavel_nome = "";

        $q.notify({
          message: "Responsável removido com sucesso!",
          color: "positive",
        });

        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao remover responsável",
          color: "negative",
        });
      }
    };

    const selecionarTudo = async () => {
      selecionados.value = ["1"];
      selecionados.value.pop();
      rows.value.forEach((e) => {
        if (e.purchase_order_id == null) {
          selecionados.value.push(e);
        }
      });
    };

    const abrirHistoricoItem = async (item) => {
      try {
        itemSelecionado.value = item;
        historicoItemDialog.value = true;
        historicoItemCarregando.value = true;
        historicoItemErro.value = null;

        const response = await store.dispatch(
          "comprasSolicitante/getHistoricoItemNecessidade",
          {
            necessidadeId: id,
            itemId: item.uuid_item,
          }
        );

        historicoItemItens.value = processarHistoricoItem(response);
      } catch (error) {
        //historicoItemErro.value = error.response?.data?.message || "Erro ao carregar histórico";
      } finally {
        historicoItemCarregando.value = false;
      }
    };

    const formatarData = (dataString) => {
      if (!dataString) return "";
      const data = new Date(dataString);
      return data.toLocaleString("pt-BR");
    };

    const processarHistoricoItem = (data) => {
      return [...data]
        .sort((a, b) => new Date(b.editado_em) - new Date(a.editado_em))
        .map((item) => ({
          ...item,
          nome: item.nome || itemSelecionado.value?.produto_nome,
          editado_em: item.editado_em || "-",
          editado_por: item.editado_por || { nome: "-", matricula: "-" },
          quantidade_necessaria: item.quantidade_necessaria || "-",
        }));
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    watch(
      () => props.get,
      () => {
        getDados();
      }
    );

    const abrirImpressaoEmNovaAba = () => {
      const routeData = router.resolve({
        name: "compras-form-sup",
        params: { id: id },
      });
      window.open(routeData.href, "_blank");
    };

    return {
      pagination,
      rows,
      disable,
      columns,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selecionados,
      rota,
      deletar,
      selecionarTudo,
      criarRequisicao,
      editar,
      removerResponsavel,
      historicoItemDialog,
      historicoItemCarregando,
      historicoItemItens,
      historicoItemErro,
      abrirHistoricoItem,
      formatarData,
      itemSelecionado,
      columnsHistoricoItem,
      processarHistoricoItem,
      abrirImpressaoEmNovaAba,
      iniciarEdicao,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}

.no-wrap {
  flex-wrap: nowrap !important;
}

.target {
  cursor: pointer;
  color: #4a93f8;
}

.my-special-class {
  background-color: #c1dec1 !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
